var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeadlineCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 50,
    height: 50,
    rx: 10,
    fill: "#495AF2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.332 13.334V16.834",
    stroke: "#495AF2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.668 13.334V16.834",
    stroke: "#495AF2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.082 21.6055H34.9154",
    stroke: "#495AF2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6654 33.1667C36.6654 34.0417 36.4204 34.87 35.9887 35.57C35.1837 36.9233 33.702 37.8333 31.9987 37.8333C30.8204 37.8333 29.747 37.4017 28.9304 36.6667C28.5687 36.3633 28.2537 35.99 28.0087 35.57C27.577 34.87 27.332 34.0417 27.332 33.1667C27.332 30.5883 29.4204 28.5 31.9987 28.5C33.3987 28.5 34.647 29.1183 35.4987 30.0866C36.222 30.915 36.6654 31.9883 36.6654 33.1667Z",
    stroke: "#495AF2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1797 33.1668L31.3347 34.3218L33.8197 32.0234",
    stroke: "#495AF2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 20.9173V30.0873C34.6483 29.119 33.4 28.5007 32 28.5007C29.4217 28.5007 27.3333 30.589 27.3333 33.1673C27.3333 34.0423 27.5783 34.8706 28.01 35.5706C28.255 35.9906 28.57 36.364 28.9317 36.6673H20.3333C16.25 36.6673 14.5 34.334 14.5 30.834V20.9173C14.5 17.4173 16.25 15.084 20.3333 15.084H29.6667C33.75 15.084 35.5 17.4173 35.5 20.9173Z",
    stroke: "#495AF2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9949 26.9837H25.0054",
    stroke: "#495AF2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6785 26.9837H20.689",
    stroke: "#495AF2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6785 30.4837H20.689",
    stroke: "#495AF2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeadlineCalender);
export default __webpack_public_path__ + "static/media/deadline-calender.9e22f60e8124da3d7d8f8b7d1c4f3767.svg";
export { ForwardRef as ReactComponent };